'use client';

import { c as _c } from "react/compiler-runtime";
import type { Metadata } from 'next';
import { useEffect } from 'react';
import { ErrorLayout } from '@/app/components/error-layout';
import { ERROR_DATA, ERROR_PAGE_ATTRIBUTE } from '@/app/contents/errors';
import { CV_METADATA } from '@/app/cv/contents/metatag';
import { LCV_METADATA } from '@/app/lcv/contents/metatag';
import type { VehicleType } from '@/app/types/vehicle-type';
import { isServer } from '@/app/utils/browser';
import { stripSpanTags } from '@/app/utils/format';
import logger from '@/lib/logger';
const VEHICLE_TYPE = `${process.env.NEXT_PUBLIC_WEB}` as VehicleType;
const IS_LCV = process.env.NEXT_PUBLIC_WEB === 'lcv';
const META_TITLE = IS_LCV ? '500 - อีซูซุประเทศไทย Isuzu Thailand Official' : '500 - ISUZU TRUCKS Thailand Official';
const META_DESCRIPTION = stripSpanTags(ERROR_DATA[500].description);
const METADATA_CONFIG = IS_LCV ? LCV_METADATA : CV_METADATA;
export const metadata: Metadata = {
  title: META_TITLE,
  description: META_DESCRIPTION,
  openGraph: {
    ...METADATA_CONFIG.openGraph,
    title: META_TITLE,
    description: META_DESCRIPTION
  },
  alternates: METADATA_CONFIG.alternates
};
interface ErrorProps {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
}
export default function Error(t0) {
  const $ = _c(3);
  const {
    error
  } = t0;
  let t1;
  if ($[0] !== error) {
    t1 = [error];
    $[0] = error;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useEffect(_temp3, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ErrorLayout vehicleType={VEHICLE_TYPE} status="500" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp3() {
  if (!isServer) {
    document.body.setAttribute(ERROR_PAGE_ATTRIBUTE, "true");
  }
  window.onerror = _temp;
  return _temp2;
}
function _temp2() {
  document.body.removeAttribute(ERROR_PAGE_ATTRIBUTE);
}
function _temp(message, url, line, column, error_0) {
  logger.error(`[Page 500]: ${message} ${error_0?.cause}`);
  console.log(message, url, line, column, error_0);
}